import { render, staticRenderFns } from "./SelectModel.vue?vue&type=template&id=a80e558a&scoped=true"
import script from "./SelectModel.vue?vue&type=script&lang=js"
export * from "./SelectModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e558a",
  null
  
)

export default component.exports